import { Helmet } from "react-helmet-async"
import { TripActivityVoucher } from "../../../../../Trips"
import { useTripDetailsOutletContext } from "../_trip-details-context"
import { FeatureFlag } from "../../../../../Auth"

export default function TripActivityVoucherPage() {
	const { trip, hasChangesBetweenQuoteAndBookings } =
		useTripDetailsOutletContext()
	return (
		<>
			<Helmet>
				<title>Trip Activity Voucher Docs</title>
			</Helmet>

			<FeatureFlag show404 flag="travel_activities">
				<TripActivityVoucher
					trip={trip}
					disabledSharing={hasChangesBetweenQuoteAndBookings}
				/>
			</FeatureFlag>
		</>
	)
}
